<template>
  <div class="post-header-parent">
    <header>
      <img :src="userInfo.profileImageUrl" alt="owner" class="owner-img" draggable="false"/>
      <div class="owner">
        <router-link class="owner-name" :to="userProfileLink">{{ userInfo.userName }}</router-link>
      </div>
      <template v-if="postInfo.lastUpdated">
        <span class="time-since-dot">•</span>
        <time class="time-since">{{ postInfo.lastUpdated }}</time>
      </template>
      <template v-if="showFollow">
        <span class="follow-dot">•</span>
        <b-button class="follow" variant="light"
                  @click="follow">Follow
        </b-button>
      </template>
    </header>
<!--    temporarily disabling three dots as delete and edit post api yet not available-->
    <span class="post-menu" v-show="!isActiveUserPost">
            <b-icon font-scale="1.8" icon="three-dots" style="cursor:pointer;"
                    @click="openPostMenu"></b-icon>
          </span>

    <PostMenu v-if="showPostMenu" :mobile="mobile" :post="post"
              @closePopup="closePopup"
              @selectedOption="onOptionSelected"/>
    <ReportPost v-if="showReportPost" :categories="postReportCategories"
                :mobile="mobile" :post="post"
                @closePopup="closePopup"
    ></ReportPost>
    <BlockUser v-if="showUnfollowUser" :mobile="mobile"
               :user-info="userInfo"
               @closePopup="closePopup"
    ></BlockUser>
  </div>
</template>
<script>
import PostMenu from "@/module_social/components/post/PostMenu";
import ReportPost from "@/module_social/components/post/ReportPost";
import BlockUser from "@/module_social/components/user/BlockUser";
import {createNamespacedHelpers} from "vuex";
import postMixins from "@/module_social/mixins/postMixins";

const {
  mapActions: reportActions,
  mapGetters: reportGetters,
} = createNamespacedHelpers("social");

export default {
  mixins: [postMixins],
  components: {
    PostMenu,
    ReportPost,
    BlockUser,
  },
  data() {
    return {
      showPostMenu: false,
      showReportPost: false,
      showUnfollowUser: false,
    }
  },
  props: {
    mobile: {
      type: Boolean, default: false
    },
    postReportCategories: {
      type: Array, default: () => ([
        "It's spam",
        "Nudity or sexual activity",
        "Hate speech or symbols",
        "Violence or dangerous organizations",
        "Sale of illegal or regulated goods",
        "Bullying or harassment",
        "Intellectual property violation",
        "Suicide, self-injury or eating disorders",
        "Scam or fraud",
        "False information"
      ]), deep: true
    },
    post: {
      type: Object, default: null, deep: true
    }
  },
  computed: {
    ...reportGetters(['socialUserInfo']),

    isActiveUserPost() {
      const activeUserId = this.socialUserInfo && this.socialUserInfo.userId;
      const postUserId = this.userInfo.userId;
      return activeUserId && postUserId && activeUserId === postUserId;
    },
    showFollow() {
      return !this.isActiveUserPost && !this.userInfo.followedByMe;
    },
    userProfileLink() {
      return `/social/user/${this.postInfo.creatorId}`;
    }
  },
  methods: {
    ...reportActions(['followUser', 'unFollowUser', 'blockUser', 'unBlockUser']),

    async follow(isFollow) {
      return isFollow
          ? this.followUser(this.userInfo.userId)
          : this.unFollowUser(this.userInfo.userId);
    },
    async block(isBlocked) {
      return isBlocked
          ? this.blockUser(this.userInfo.userId)
          : this.unBlockUser(this.userInfo.userId);
    },
    openPostMenu() {
      this.showPostMenu = true;
      this.showReportPost = false;
      this.showUnfollowUser = false;
    },
    closePopup() {
      this.showPostMenu = false;
      this.showReportPost = false;
      this.showUnfollowUser = false;
    },
    async onOptionSelected(selected) {
      this.showPostMenu = false;
      switch (selected) {
        case 'report-post':
          this.showReportPost = true;
          break;
        case 'delete-post':
          console.log(selected);
          break;
        case 'edit-post':
          this.$emit('editPost', this.post.id);
          break;
        case 'unfollow-user':
          this.showUnfollowUser = true;
          break;
        case 'follow-user':
          await this.follow(true);
          this.closePopup();
          break;
        case 'block-user':
          await this.block(true);
          this.closePopup();
          break;
        case 'unblock-user':
          await this.block(false);
          this.closePopup();
          break;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/_social.scss";

.post-header-parent {
  display: flex;
  align-items: center;
}

header {
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 1;
  max-width: calc(100% - #{$dim-6x});
  padding: $spacing-1x $spacing-half-x $spacing-1x $spacing-2x;

  .time-since-dot, .follow-dot {
    margin-left: 4px;
    margin-right: 4px;
    color: $darker-gray;
  }

  .follow {
    color: $blue;
    background-color: transparent;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    border: none;
    outline: none;

    &:active, &:focus {
      outline: none;
      box-shadow: none;
      background-color: transparent;
    }
  }

  .time-since {
    color: $darker-gray;
    line-height: $font-size-4x;
    font-size: $font-size-2x;
    word-break: break-word;
    white-space: pre-line;
    font-weight: 500;
  }

  .owner-img {
    width: $dim-5x;
    height: $dim-5x;
    border-radius: 50%;
    border: 1px solid $light-gray;
    background-color: $white;
    margin-right: $spacing-2x;
  }

  .owner {
    ::v-deep.owner-name {
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      font-size: $font-size-3x;
      font-weight: 600;
      margin-right: $spacing-half-x;
      text-overflow: ellipsis;
      justify-content: center;
      color: $black;
    }
  }
}

.post-menu {

}
</style>